export default "Helicopter pilot reports Engine Fire on short final.\nFire is difficult to put out.\nPitch +/- 2.5 Roll +/- 6 which is outside SHOL.";